import { navLinks } from '@/mocks/news';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto py-12 md:py-14">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
            <div className="md:col-span-5">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                  <i className="ri-flashlight-fill text-lg" aria-hidden="true"></i>
                </span>
                <span className="font-heading text-2xl font-black tracking-tight">黑料网1</span>
              </div>
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/80">
                黑料网1更新页，把今日头条、新料快讯与专题合集收在同一条滚动时间线上，
                蹲最新进展不用来回切换页面。
              </p>
              <div className="mt-5 flex items-center gap-3">
                {['ri-rss-line', 'ri-notification-3-line', 'ri-share-forward-line'].map((icon) => (
                  <button
                    key={icon}
                    type="button"
                    className="w-10 h-10 flex items-center justify-center rounded-md bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer"
                    aria-label="订阅入口（示意）"
                  >
                    <i className={`${icon} text-lg`} aria-hidden="true"></i>
                  </button>
                ))}
              </div>
            </div>

            <div className="md:col-span-3">
              <h6 className="text-xs font-medium tracking-[0.2em] text-accent-300">页面导航</h6>
              <ul className="mt-4 grid grid-cols-2 gap-y-3 gap-x-4">
                {navLinks.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-4">
              <h6 className="text-xs font-medium tracking-[0.2em] text-accent-300">更新提示</h6>
              <p className="mt-4 text-sm leading-relaxed text-background-100/80">
                新料发布后，快讯时间线与热搜榜会一起刷新；建议整点回来看一眼，避免漏掉关键回应。
              </p>
              <a
                href="#top"
                className="mt-5 inline-flex items-center justify-center gap-2 h-10 px-4 rounded-md bg-accent-500 text-primary-950 text-sm font-medium hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-up-line" aria-hidden="true"></i>
                回到顶部
              </a>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <p className="text-xs text-background-100/70">
              © {new Date().getFullYear()} 黑料网1 · 本页为静态展示页面，内容为示意条目
            </p>
            <p className="text-xs text-background-100/60">
              黑料网1最新 · 黑料网1今日 · 黑料网1头条
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}